module.exports = __webpack_public_path__ + "img/ucenter.8aceb65b.png";